import React from 'react';

export type ProgressStage = 'intake' | 'process' | 'results';

const STAGES: { key: ProgressStage; label: string }[] = [
  { key: 'intake',  label: 'Intake' },
  { key: 'process', label: 'Process' },
  { key: 'results', label: 'Results' },
];

export const ProgressTrack: React.FC<{
  activeStage: ProgressStage;
  statusMessage?: string;
}> = ({ activeStage, statusMessage }) => {
  const activeIdx = STAGES.findIndex((s) => s.key === activeStage);

  return (
    <div
      aria-label="Progress"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.75rem',
        marginBottom: '1.5rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        {STAGES.map((stage, idx) => {
          const isActive = idx === activeIdx;
          const isDone = idx < activeIdx;
          const color = isActive ? '#3498db' : isDone ? '#27ae60' : '#bdc3c7';
          return (
            <React.Fragment key={stage.key}>
              <div
                aria-current={isActive ? 'step' : undefined}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '4px 12px',
                  borderRadius: '999px',
                  border: `2px solid ${color}`,
                  background: isActive ? '#e3f2fd' : isDone ? '#e8f5e9' : 'transparent',
                  color,
                  fontSize: '0.9rem',
                  fontWeight: isActive ? 600 : 500,
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    background: color,
                    color: 'white',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                  }}
                >
                  {isDone ? '✓' : idx + 1}
                </span>
                {stage.label}
              </div>
              {idx < STAGES.length - 1 && (
                <div
                  aria-hidden="true"
                  style={{
                    width: '24px',
                    height: '2px',
                    background: idx < activeIdx ? '#27ae60' : '#bdc3c7',
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {statusMessage && (
        <div
          aria-live="polite"
          role="status"
          style={{
            fontSize: '0.95rem',
            color: '#2c3e50',
            textAlign: 'center',
          }}
        >
          {statusMessage}
        </div>
      )}
    </div>
  );
};
